import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { extractElement } from "../../../util";
import { whitelistStyles } from "../hoc";
import cx from 'classnames';
import { sizes, textAlignments } from "../../../enums";
import Icon from "../icon";
import Header from "../header";
var EmptyState = createComponent({
  displayName: 'EmptyState',
  propTypes: {
    header: PropTypes.string.isRequired,
    byline: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    textAlign: PropTypes.oneOf(textAlignments.ALL),
    hasOutline: PropTypes.bool,
    action: PropTypes.element,
    contentAlign: PropTypes.oneOf([textAlignments.LEFT, textAlignments.RIGHT, textAlignments.CENTER])
  },
  defaultProps: {
    byline: undefined,
    icon: undefined,
    textAlign: textAlignments.LEFT,
    hasOutline: false,
    action: undefined,
    contentAlign: textAlignments.CENTER
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    var _cx;

    var hasValidAction = /*#__PURE__*/React.isValidElement(props.action);

    var _cls = cx('ck empty-state', (_cx = {
      outline: props.hasOutline
    }, _cx["empty-state--" + props.contentAlign] = !!props.contentAlign, _cx['empty-state--no-action'] = !hasValidAction, _cx));

    var icon = props.icon ? extractElement(Icon, props.icon, {
      name: props.icon,
      size: sizes.X8
    }).element : undefined;
    return /*#__PURE__*/React.createElement("div", {
      className: _cls,
      style: props.style
    }, props.icon ? /*#__PURE__*/React.createElement("div", {
      className: "empty-state__icon"
    }, icon) : null, /*#__PURE__*/React.createElement("div", {
      className: "empty-state__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "empty-state__header"
    }, /*#__PURE__*/React.createElement(Header, {
      text: props.header,
      byline: props.byline,
      textAlign: props.textAlign
    })), hasValidAction ? /*#__PURE__*/React.createElement("div", {
      className: "empty-state__action"
    }, props.action) : null));
  }
});
export default whitelistStyles()(EmptyState);
//# sourceMappingURL=index.js.map